<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.092 24.092"
    aria-hidden="true"
  >
    <path
      id="noun-534806"
      d="M12.046,24.092A12.046,12.046,0,0,1,12.046,0a1,1,0,0,1,0,2.008A10.038,10.038,0,1,0,22.085,12.046a1,1,0,1,1,2.008,0A12.06,12.06,0,0,1,12.046,24.092Zm0-22.085a1.056,1.056,0,0,1-.713-.291A1.056,1.056,0,0,1,11.042,1a1.056,1.056,0,0,1,.291-.713,1.051,1.051,0,0,1,1.425,0A1.056,1.056,0,0,1,13.05,1a1.056,1.056,0,0,1-.291.713A1.056,1.056,0,0,1,12.046,2.008ZM21.322,8.2a1.006,1.006,0,1,1,1.315.542,1.084,1.084,0,0,1-.381.08A1,1,0,0,1,21.322,8.2ZM19.142,4.949a1.012,1.012,0,0,1,0-1.425,1,1,0,0,1,1.415,0,1,1,0,0,1-.7,1.717A1.033,1.033,0,0,1,19.142,4.949ZM15.891,2.771A1.006,1.006,0,0,1,16.664.913a1,1,0,0,1-.392,1.927A.989.989,0,0,1,15.891,2.771Zm7.2,10.279a.994.994,0,1,1,.713-.291A1.054,1.054,0,0,1,23.088,13.05Zm-7.028,2.008a1.007,1.007,0,0,1-.448-.105L11.6,12.945a1,1,0,0,1-.555-.9V5.019a1,1,0,1,1,2.008,0v6.407l3.46,1.731a1,1,0,0,1-.45,1.9Z"
      fill="currentColor"
    />
  </svg>
</template>
